module.exports = __webpack_public_path__ + "img/handyman.97d1f789.jpg";